<template>
  <div class="research-1001-data-scientists-container">
    <iframe
      src="https://app.powerbi.com/view?r=eyJrIjoiNmQzNjVjOTYtMjAwZi00NjE3LThjNTktOGY5YTQzOWE1OWFmIiwidCI6IjcwOGU2OTA5LTdlMTctNDEyNS1hMWRjLTg0ZDg5NjBmOTRjZiIsImMiOjl9"
      width="800px" height="600px" frameborder="0"
      allowfullscreen="allowfullscreen" data-rocket-lazyload="fitvidscompatible"
      data-ll-status="loaded"
    />
  </div>
</template>

<script>
import global from '@itbpbg/lms-components/src/mixins/global';

export default {
  mixins: [global],
  async asyncData({ $axios, route, $config }) {
    const page = await $axios.$get(`/pages${route.fullPath}`);
    page.fullPath = `${$config.siteUrl}${route.fullPath}`;
    page.metaFullImageUrl = `${$config.siteUrl}/resources/${page.metaImage}`;

    page.created = page.created || new Date();
    page.updated = page.updated || new Date();

    return {
      page,
      metaTitle: `${page.metaTitle}${+route.query.page > 1 ? ` - Page ${route.query.page}` : ''}`,
    };
  },
  head() {
    const linkedData = this.$linkedDataLoad([
      { key: 'WebSite' },
      { key: 'WebPage', values: this.page },
    ]);

    return {
      titleTemplate: `${this.page.metaTitle}%s`,
      link: [
        { rel: 'canonical', href: this.canonicalURL() },
      ],
      meta: this.metaProps(this.page),
      script: [linkedData],
    };
  },
};
</script>

<style lang="scss">

iframe {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
  border: none;
  margin: 0;
  overflow: hidden;
  z-index: 999999;
}

</style>
